module.exports = __webpack_public_path__ + "static/media/crowd-at-concert.599415c0.jpg";